import _ from 'lodash';
import {
    COVERAGES_LOAD,
    COVERAGES_UPDATE,
    COVERAGES_HISTORY_LOAD,
} from '../actions/types';

const INITIAL_STATE = {
    products: null,
    coverages: null,
    loaded: false,
    history: {
        products: null,
        coverages: null,
        benefitPeriods: null,
        loaded: false,
    },
};

const coveragesReducer = (state = INITIAL_STATE, action) => {
    const {type, payload} = action;
    switch (type) {
        case COVERAGES_UPDATE:
            return _.assign({}, state, {
                coverages: {
                    ...state.coverages,
                    [payload.member]: payload.coverages[payload.member],
                },
            });
        case COVERAGES_LOAD:
            return payload;
        case COVERAGES_HISTORY_LOAD:
            return _.assign({}, state, {
                history: payload,
            });
        default:
            return state;
    }
};

export default coveragesReducer;